<template>
  <div class="test_paper">
    <!-- 章节测试展示倒计时 -->
    <div class="paper_top flex Flexalign FlexBetween" v-if="!hideCountDown">
      <div class="empty"></div>
      <div class="count_down" v-if="countDown >= 0 && !testExamInfo.isShowScoring">
        倒计时：{{ $Tools.convertMinutesToCountdown(countDown) }}
      </div>
      <div class="count_down" v-else-if="countDown < 0 && !testExamInfo.isShowScoring">
        倒计时：{{ $Tools.convertMinutesToCountdown(0) }}
      </div>
      <div class="flex Flexalign cursor_pointer" @click="backStep" v-if="!hideBackBtn">
        <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
        <div class="back_text">返回</div>
      </div>
    </div>
    <!-- 随堂练习展示 -->
    <div class="paper_top flex Flexalign FlexBetween" v-if="hideCountDown">
      <div class="empty"></div>
      <!-- <div v-if="!testType">随堂练习</div> -->
      <div
        class="flex Flexalign cursor_pointer"
        @click="practiceBack"
        v-if="!hideBackBtn"
      >
        <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
        <div class="back_text">返回</div>
      </div>
    </div>
    <div class="test_title my-20">{{ testTitle }}</div>
    <!-- 暂无统计，先做隐藏 -->
    <!-- <div class="test_type mt-10" v-if="testType">
      <div class="paper_top flex Flexalign Flexjustify" v-if="testExamInfo.otherRule?.timeType == 3">
        <div class="count_down" v-if="countDown >= 0 && !testExamInfo.isShowScoring">
          倒计时：{{ $Tools.convertMinutesToCountdown(countDown) }}
        </div>
        <div class="count_down" v-else-if="countDown < 0 && !testExamInfo.isShowScoring">
          倒计时：{{ $Tools.convertMinutesToCountdown(0) }}
        </div>
      </div>
      <div class="progress_list flex Flexalign Flexjustify mt-20" v-if="isChallenge">
        <div
          class="progress_one ml-50 flex flexcolumn Flexalign"
          v-for="(item, index) in progressList"
          :key="index"
        >
          <el-progress
            type="circle"
            :color="(percentage) => formatColor(percentage, item)"
            :width="100"
            :format="(percentage) => formatContent(percentage, item)"
            :percentage="(item.finishedNum / item.total) * 100"
          />
          <div class="mt-10">{{ item.label }}</div>
        </div>
      </div>
      <div class="test_title mt-20">
        {{ isChallengeSubmit ? "" : testPaperInfo.paperName }}
      </div>
    </div> -->
    <div
      v-for="(sitem, sindex) in testPaperInfo.paperContext"
      :key="sindex + refreshPaperListKey"
    >
      <div v-for="(item, index) in sitem.questions" :key="index + refreshPaperListKey">
        <!-- 单选 -->
        <choice
          v-if="
            (item.questionTypeId == 1 || item.questionTypeId == 9) &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="item"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        ></choice>
        <!-- 多选 -->
        <multipleChoice
          v-else-if="
            item.questionTypeId == 2 &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="JSON.stringify(item)"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        ></multipleChoice>
        <!-- 判断/听力判断 -->
        <trueOrFalseVue
          v-else-if="
            (item.questionTypeId == 4 || item.questionTypeId == 11) &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="item"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        ></trueOrFalseVue>
        <!-- 排序 -->
        <sortNew
          v-else-if="
            (item.questionTypeId == 6 || item.questionTypeId == 15) &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="item"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        >
        </sortNew>
        <!-- 填空题 -->
        <fillIn
          v-else-if="
            (item.questionTypeId == 3 || item.questionTypeId == 14) &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="item"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        >
        </fillIn>
        <!-- 书写解答题 -->
        <textAnswer
          v-else-if="
            (item.questionTypeId == 7 ||
              item.questionTypeId == 16 ||
              item.questionTypeId == 13 ||
              item.questionTypeId == 17) &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="item"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        >
        </textAnswer>
        <!-- 综合解答题 -->
        <comprehensiveAnswer
          v-else-if="
            (item.questionTypeId == 99 || item.questionTypeId == 101) &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="item"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        >
        </comprehensiveAnswer>
        <!-- 完形填空题 -->
        <clozeTest
          v-else-if="
            (item.questionTypeId == 102 || item.questionTypeId == 103) &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="item"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        >
        </clozeTest>
        <!-- 信息匹配题 -->
        <informationMacth
          v-else-if="
            item.questionTypeId == 32 &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="item"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        >
        </informationMacth>
        <composition
          v-else-if="
            (item.questionTypeId == 21 || item.questionTypeId == 22) &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
          :questionInfo="item"
          @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring"
          :questionTypeName="sitem.questionTypeName"
          :testType="testType"
          @showAnalysis="showAnalysis"
          :isChallenge="isChallenge"
        >
        </composition>
        <!-- 连线题 -->
        <!-- <connection v-else-if="
          item.questionTypeId == 31 &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion" :isShowScoring="testExamInfo.isShowScoring"
          :questionTypeName="sitem.questionTypeName"></connection> -->
        <div
          v-else-if="
            item.questionTypeId != 1 &&
            item.questionTypeId != 2 &&
            item.questionTypeId != 4 &&
            item.questionTypeId != 6 &&
            item.questionTypeId != 3 &&
            item.questionTypeId != 7 &&
            item.questionTypeId != 99 &&
            item.questionTypeId != 102 &&
            item.questionTypeId != 103 &&
            item.questionTypeId != 101 &&
            item.questionTypeId != 14 &&
            item.questionTypeId != 15 &&
            item.questionTypeId != 11 &&
            item.questionTypeId != 9 &&
            item.questionTypeId != 16 &&
            item.questionTypeId != 13 &&
            item.questionTypeId != 17 &&
            item.questionTypeId != 32 &&
            item.questionTypeId != 21 &&
            item.questionTypeId != 22 &&
            // item.questionTypeId != 31 &&
            testExamInfo.currentQuestionId == item.questionNumber
          "
        >
          <moe-empty url="development_icon.png" emptyText="更多题型开发中"></moe-empty>
        </div>
      </div>
    </div>
    <div class="flex Flexalign btn_box mar_top_30">
      <div
        class="btn_previous_question cursor_pointer"
        @click="getPreviousQuestion"
        v-if="!isChallenge || testExamInfo.isShowScoring"
      >
        上一题
      </div>
      <!-- 暂时先隐藏，将逻辑放入下一题中 -->
      <!-- <div class="btn_next_question mar_left_30 cursor_pointer" @click="showAnalysis" v-if="
        (testExamInfo.otherRule?.answerFeedback == 1 ||
          testExamInfo.otherRule?.answerFeedback == 2) &&
        testExamInfo.otherRule?.mode == 1 && !testExamInfo.isShowScoring
      ">
        查看结果
      </div> -->
      <div
        class="btn_previous_question mar_left_30 cursor_pointer"
        @click="getNextQuestion"
      >
        {{ nextBtnText }}
      </div>
      <!-- 纠错 -->
      <div
        class="btn_next_question mar_left_30 cursor_pointer"
        v-if="!isChallenge && schoolMenu == 4 && !isWrongReubmit"
        @click="confirmQuestion"
      >
        确定
      </div>
    </div>
    <challengePopup ref="challengePopup" @back="practiceBack"></challengePopup>
  </div>
</template>

<script>
import choice from "@/components/testPaper/choice.vue";
import multipleChoice from "@/components/testPaper/multipleChoice.vue";
import { mapState } from "vuex";
import trueOrFalseVue from "@/components/testPaper/trueOrFalse.vue";
import sortNew from "@/components/testPaper/sortNew.vue";
import fillIn from "@/components/testPaper/fillIn.vue";
import textAnswer from "@/components/testPaper/textAnswer.vue";
import comprehensiveAnswer from "@/components/testPaper/comprehensiveAnswer.vue";
import clozeTest from "@/components/testPaper/clozeTest.vue";
import informationMacth from "@/components/testPaper/informationMacth.vue";
import challengePopup from "@/components/popup/challengePopup.vue";
import composition from "@/components/testPaper/composition.vue";
// import connection from "@/components/testPaper/connection.vue";
export default {
  name: "GjkcH5TestPaper",
  components: {
    choice,
    multipleChoice,
    trueOrFalseVue,
    sortNew,
    fillIn,
    textAnswer,
    comprehensiveAnswer,
    clozeTest,
    informationMacth,
    challengePopup,
    composition,
    // connection
  },
  computed: {
    ...mapState({
      testExamInfo: (state) => state.exam.testExamInfo,
      questionTypeList: (state) => state.exam.questionTypeList,
      currentQuestionId: (state) => state.exam.currentQuestionId,
      isChallengeSubmit: (state) => state.exam.isChallengeSubmit,
      challengeSort: (state) => state.exam.challengeSort,
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      examIsBack: (state) => state.exam.examIsBack
    }),
  },
  props: {
    examInfo: {},
    hideCountDown: {},
    testTitle: {},
    testType: {},
    isHome: {},
    isChallenge: {},
    isFinalStep: {},
    schoolMenu: {}, // 用于判断是否是闯关，闯关不展示得分等信息
    isWrongReubmit: {}, // 用于控制错题重做还是练习，为true是重做，不要确定按钮
    hideBackBtn: {}, // 用于考试隐藏返回按钮
  },
  watch: {
    // 监听缓存的考试信息，如果提交完展示得分，停止计时
    testExamInfo: {
      handler(val) {
        if (this.testExamInfo.isShowScoring) {
          this.nextBtnText = "下一题";
          this.refreshPaperListKey++;
          this.testPaperInfo = this.$Tools.copyObj(val);
          // 回显答案后清除定时器
          if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = "";
          }
        }
      },
      deep: true,
    },
    examInfo: {
      handler(val) {
        this.testPaperInfo = this.$Tools.copyObj(val);
        this.countDown = this.testPaperInfo.answerTime * 60;
        this.startTime = this.$Moment().format("YYYY-MM-DD HH:mm:ss");
        this.handleTestPaperInfo();
        this.timerInterval = setInterval(() => {
          this.countDown--;
          // 缓存考试剩余时间（做自动交卷/限制答题效果） 随堂练习hideCountDown为true，不展示倒计时
          if (!this.hideCountDown) {
            this.$store.commit("exam/setTestExamTime", {
              remainingTime: this.countDown,
            });
          }
          // 考试时间到清除定时器
          if (this.countDown <= 0) {
            if (this.timerInterval) {
              clearInterval(this.timerInterval);
              this.timerInterval = "";
            }
          }
          // 监听闯关当前题实时作答是否已完成（变更按钮文字）
          if (this.isChallenge) {
            this.judgeCurrentQuestionStatus();
          }
        }, 1000);
      },
      deep: true,
      immediate: true,
    },
    currentQuestionId: {
      handler() {
        this.testPaperInfo.currentQuestionId = this.currentQuestionId;
      },
    },
    examIsBack:{
      handler(val) {
        if(val){
          this.practiceBack();
          this.$store.commit("exam/setExamIsBack", false);  // 将状态重置为false
        }
      }
    }
  },
  data() {
    return {
      countDown: "",
      testPaperInfo: {},
      timerInterval: "",
      startTime: "",
      progressList: [
        { label: "答题进度", finishedNum: 10, total: 100, type: "fraction" },
        { label: "答题时间", finishedNum: 90, total: 300, type: "time" },
        { label: "正确率", finishedNum: 20, total: 100, type: "percent" },
      ],
      // 当前题目ID
      // currentQuestionId:'',
      pushIndex: 0,
      paperCommitBackInfo: {}, // 闯关返回结果
      refreshPaperListKey: 1,
      nextBtnText: "下一题",
    };
  },

  created() {},
  unmounted() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = "";
    }
    // 刷新答题卡缓存
    this.$emit("refreshTextExam");
    // 清空缓存的试卷信息
    this.$store.commit("exam/setTestExamInfo", {});
    this.$store.commit("exam/setCurrentQuestionId", "");
    this.$store.commit("exam/setIsChallengeSubmit", false);
  },

  methods: {
    // 判断当前题的作答状态
    judgeCurrentQuestionStatus() {
      // 判断是否是最后一题，最后一题完成将按钮变为提交试卷
      let lastQuestionNumber = "";
      this.testPaperInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            if (
              sitem.questionContext.isFinish &&
              !this.testExamInfo.isShowScoring &&
              sitem.showAnalysis
            ) {
              this.nextBtnText = "下一题";
            } else {
              this.nextBtnText = "提交";
            }
          }
          lastQuestionNumber = sitem.questionNumber;
        });
      });
      if (
        lastQuestionNumber == this.testExamInfo.currentQuestionId &&
        this.nextBtnText == "下一题"
      ) {
        this.nextBtnText = "试卷提交";
        // 直接提交
        this.getNextQuestion();
      }
    },
    formatContent(percentage, info) {
      if (info.type == "fraction") {
        return `${info.finishedNum}/${info.total}`;
      } else if (info.type == "time") {
        return this.$Tools.secondToMinuteFormat(info.finishedNum);
      } else if (info.type == "percent") {
        return (info.finishedNum / info.total) * 100 + "%";
      }
    },
    formatColor(percentage, info) {
      if (info.type == "fraction") {
        return `RGBA(0, 213, 189, 1)`;
      } else if (info.type == "time") {
        return "RGBA(255, 130, 0, 1)";
      } else if (info.type == "percent") {
        return `RGBA(0, 213, 189, 1)`;
      }
    },
    // 闯关返回
    practiceBack() {
      this.$emit("practiceBack", false, this.isHome, this.isChallenge);
    },
    backStep() {
      if (!this.testTitle) {
        this.$emit("backStep", 2);
      } else {
        this.$emit(
          "practiceBack",
          false,
          this.isHome,
          this.isChallenge,
          this.isFinalStep
        );
      }
    },
    // 查题型id
    // getQuestionType(id){
    // let index = this.questionTypeList.findIndex(item=>)
    // },
    // 处理试卷内容
    handleTestPaperInfo() {
      // 判断试题内容是否存在
      if (this.testPaperInfo.paperContext) {
        this.testPaperInfo.paperContext.forEach((sitem) => {
          sitem.questions.forEach((item) => {
            // 解析富文本图片配置
            item.questionAnalyze = this.handlerImg(item.questionAnalyze);
            item.questionTitle = this.handlerImg(item.questionTitle);
            item.questionExplanation = this.handlerImg(item.questionExplanation);
            // item.questionContext = this.$Tools.jsonDecode(item.questionContext);
            // item.answerTimeSection = this.$Tools.jsonDecode(
            //   item.answerTimeSection
            // );
            // 没有提交过需要配置(作业无配置，此处看是否需要添加测试判断是否限制提交次数)
            // if (!item.courseExamRecordId) {
            item.questionContext = {
              ...item.questionContext,
              // doAnswer: "",
              showAnalysis: false,
              startTime: this.startTime,
              isFinish: false,
              isShowScoring: false,
            }; // 新增用户填的答案字段doAnswer,是否显示解析showAnalysis,是否已完成isFinish
            item.doAnswer = ""; // 答案
            item.isCorrect = 2; // 是否正确：1：正确 2：错误
            item.questionScore = item.isCorrect == 1 ? item.questionContext.score : 0; // 得分
            item.startTime = this.startTime;
            // 此处加上判断不同题型的doAnswer格式不同（如多选题需为数组）
            if (item.questionTypeId == 2) {
              item.doAnswer = [];
            }
            // 此处加上判断不同题型的doAnswer格式不同（如作文题需为对象----上传需转成json字符串）
            if (item.questionTypeId == 21 || item.questionTypeId == 22) {
              item.doAnswer = {
                title: "",
                content: "",
                image: [],
                imageList: [],
              };
            }
            // 此处加上判断,当为填空题的时候，此时要再每个空上面加入一个用户答案字段（用来判断正确与否）
            if (item.questionTypeId == 3) {
              item.questionContext?.options.forEach((item) => {
                item.doAnswer = "";
              });
            }
            // 此处加上判断,当为信息匹配题的时候，此时要新增一个数组用来放用户答案，后端只返回了填空数量
            if (item.questionTypeId == 32) {
              item.doOptions = [];
              for (let k = 0; k < item.questionContext?.blankCount; k++) {
                item.doOptions.push({ doAnswer: "" });
              }
            }
            // 此处加上判断,当为综合解答题/完形填空的时候
            if (
              item.questionTypeId == 99 ||
              item.questionTypeId == 101 ||
              item.questionTypeId == 102 ||
              item.questionTypeId == 103
            ) {
              item.questionContext.subQuestions.forEach((item, index) => {
                item.questionId = index + 1;
                item.doAnswer = "";
                item.questionScore = 0;
                item.isCorrect = 2;
              });
            }
            // }
          });
        });
        // 第一次没有当前所做题目id设置第一个题目为当前所在题
        if (!this.testPaperInfo.currentQuestionId) {
          this.testPaperInfo.currentQuestionId = this.testPaperInfo.paperContext[0]?.questions[0]?.questionNumber; // 初始化默认第一个题目ID
          // 新增是否判分(提交后将该字段变为true，展示每题的答案，得分之类)
          this.testPaperInfo.isShowScoring = false;
        }
        this.$store.commit("exam/setTestExamInfo", this.testPaperInfo);
      }
    },
    // 富文本图片处理
    handlerImg(value) {
      value = value.replace(/<img\b([^>]*)>/gi, (match, attributes) => {
        // 1. 提取原有样式
        const styleMatch = attributes.match(/style\s*=\s*(["'])(.*?)\1/);
        let existingStyle = styleMatch ? styleMatch[2] : "";

        // 2. 添加/合并新样式（保留原有样式）
        if (!existingStyle.includes("max-width")) {
          existingStyle = `max-width:100%;height:auto;${existingStyle}`;
        } else {
          // 若已有max-width则仅补充height:auto
          existingStyle = existingStyle.replace(/max-width\s*:[^;]+;/i, "$&height:auto;");
        }
        // 3. 替换或新增style属性
        return styleMatch
          ? match.replace(styleMatch[0], ` style="${existingStyle}"`)
          : match.replace(attributes, ` style="${existingStyle}" ${attributes}`);
      });
      return value;
    },
    // 上一题
    getPreviousQuestion() {
      // 回到顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.testPaperInfo.paperContext.forEach((item, index) => {
        item.questions.forEach((sitem, sindex) => {
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            if (sindex == 0) {
              if (index == 0) {
                this.$Dialog.toast("已经是第一题啦", { type: "warning" });
                return;
              } else {
                let questionLength = this.testPaperInfo.paperContext[index - 1].questions
                  .length;
                if (questionLength == 0) return;
                this.testExamInfo.currentQuestionId = this.testPaperInfo.paperContext[
                  index - 1
                ].questions[questionLength - 1].questionNumber;
                this.$store.commit(
                  "exam/setCurrentQuestionId",
                  this.testPaperInfo.paperContext[index - 1].questions[questionLength - 1]
                    .questionNumber
                );
                return;
              }
            } else {
              this.testExamInfo.currentQuestionId =
                item.questions[sindex - 1].questionNumber;
              this.$store.commit(
                "exam/setCurrentQuestionId",
                item.questions[sindex - 1].questionNumber
              );
              return;
            }
          }
        });
      });
    },
    // 下一题
    async getNextQuestion() {
      // 回到顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 最后一题提交后整体试卷提交
      if (this.nextBtnText == "试卷提交") {
        this.commitPaper(1);
        return;
      }
      if (this.nextBtnText == "提交") {
        // 通关模式（判断对错，错了直接提交）
        if (this.testExamInfo.otherRule?.mode == 2) {
          let flag = await this.judgeIsCorrect();
          if (flag == false) {
            this.commitPaper(3);
            return;
          } else {
            this.showAnalysis();
          }
        } else if (this.testExamInfo.otherRule?.mode == 3) {
          let flag = await this.judgeIsCorrect();
          if (flag == false) {
            // 控制不给做了
            this.showAnalysis(true);
            return;
          } else {
            this.showAnalysis();
          }
        } else if (this.testExamInfo.otherRule?.mode == 1) {
          if (
            (this.testExamInfo.otherRule?.answerFeedback == 1 ||
              this.testExamInfo.otherRule?.answerFeedback == 2) &&
            !this.testExamInfo.isShowScoring
          ) {
            let flag = await this.judgeIsCorrect();
            if (flag == false) {
              // 控制不给做了
              this.showAnalysis(true);
              return;
            } else {
              this.showAnalysis();
            }
          }
        }
        // this.nextBtnText = '下一题'
        return;
      } else {
        // 查找当前题信息，仅闯关并且是已完成的情况下可以进入下一题
        let currentQuestionInfo = {};
        this.testPaperInfo.paperContext.forEach((item) => {
          item.questions.forEach((sitem) => {
            if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
              currentQuestionInfo = sitem;
            }
          });
        });
        if (
          this.isChallenge &&
          currentQuestionInfo?.questionContext.isFinish == false &&
          !this.testExamInfo.isShowScoring
        ) {
          this.$Dialog.toast("请先完成作答并提交");
          return;
        }
      }
      let shouldBreak = false; // 添加终止标记

      // 外层循环改用 for 替代 forEach
      // outerLoop:
      for (let index = 0; index < this.testPaperInfo.paperContext.length; index++) {
        const item = this.testPaperInfo.paperContext[index];

        // 内层循环改用 for 替代 forEach
        for (let sindex = 0; sindex < item.questions.length; sindex++) {
          const sitem = item.questions[sindex];

          if (sitem.questionNumber === this.testExamInfo.currentQuestionId) {
            // 逻辑判断
            if (sindex === item.questions.length - 1) {
              if (index === this.testPaperInfo.paperContext.length - 1) {
                // 加个逻辑（闯关且未提交展示答案时进入）
                if (this.isChallenge && this.testExamInfo.isShowScoring) {
                  this.commitPaper(3);
                  return;
                }
                this.$Dialog.toast("已经是最后一题啦", { type: "warning" });
              } else {
                if (
                  !this.$Tools.empty(
                    this.testPaperInfo.paperContext[index + 1].questions[0]
                  )
                ) {
                  this.testExamInfo.currentQuestionId = this.testPaperInfo.paperContext[
                    index + 1
                  ].questions[0].questionNumber;
                  this.$store.commit(
                    "exam/setCurrentQuestionId",
                    this.testPaperInfo.paperContext[index + 1].questions[0].questionNumber
                  );
                }
              }
            } else {
              this.testExamInfo.currentQuestionId =
                item.questions[sindex + 1].questionNumber;
              this.$store.commit(
                "exam/setCurrentQuestionId",
                item.questions[sindex + 1].questionNumber
              );
            }

            shouldBreak = true; // 标记需要终止
            break; // 终止内层循环
          }

          if (shouldBreak) break; // 检查外层终止标记
        }

        if (shouldBreak) break; // 终止外层循环
      }
    },
    // 错题模式
    pushWrongQuestion() {
      if (!this.$Tools.empty(this.testExamInfo.questionBank)) {
        // 错题模式可累加的题处理（添加isFinish等状态）
        this.testPaperInfo.questionBank.forEach((item) => {
          // 解析富文本图片配置
          item.questionAnalyze = this.handlerImg(item.questionAnalyze);
          item.questionTitle = this.handlerImg(item.questionTitle);
          item.questionExplanation = this.handlerImg(item.questionExplanation);
          item.questionContext = {
            ...item.questionContext,
            showAnalysis: false,
            startTime: this.startTime,
            isFinish: false,
            isShowScoring: false,
          }; // 新增用户填的答案字段doAnswer,是否显示解析showAnalysis,是否已完成isFinish
          item.doAnswer = ""; // 答案
          item.isCorrect = 2; // 是否正确：1：正确 2：错误
          item.questionScore = item.isCorrect == 1 ? item.questionContext.score : 0; // 得分
          item.startTime = this.startTime;
          // 此处加上判断不同题型的doAnswer格式不同（如多选题需为数组）
          if (item.questionTypeId == 2) {
            item.doAnswer = [];
          }
          // 此处加上判断,当为填空题的时候，此时要再每个空上面加入一个用户答案字段（用来判断正确与否）
          if (item.questionTypeId == 3) {
            item.questionContext?.options.forEach((item) => {
              item.doAnswer = "";
            });
          }
          // 此处加上判断,当为信息匹配题的时候，此时要新增一个数组用来放用户答案，后端只返回了填空数量
          if (item.questionTypeId == 32) {
            item.doOptions = [];
            for (let k = 0; k < item.questionContext?.blankCount; k++) {
              item.doOptions.push({ doAnswer: "" });
            }
          }
          // 此处加上判断,当为综合解答题/完形填空的时候
          if (
            item.questionTypeId == 99 ||
            item.questionTypeId == 101 ||
            item.questionTypeId == 102 ||
            item.questionTypeId == 103
          ) {
            item.questionContext.subQuestions.forEach((item, index) => {
              item.questionId = index + 1;
              item.doAnswer = "";
              item.questionScore = 0;
              item.isCorrect = 2;
            });
          }
        });
        // 超出可加题库不再累加
        if (this.pushIndex >= this.testExamInfo.questionBank.length) return;
        // 判断该题型是否存在。不存在要重新新建题型push
        let isExist = this.testPaperInfo.paperContext.findIndex(
          (item) =>
            item.questionTypeId ==
            this.testExamInfo.questionBank[this.pushIndex].questionTypeId
        );
        if (isExist == -1) {
          this.testPaperInfo.paperContext.push({
            paperNumber: "",
            questionTypeId: this.testExamInfo.questionBank[this.pushIndex].questionTypeId,
            questionTypeName: this.testExamInfo.questionBank[this.pushIndex]
              .questionTypeName,
            questions: [this.testExamInfo.questionBank[this.pushIndex]],
          });
        } else {
          this.testPaperInfo.paperContext.forEach((item) => {
            if (
              this.testExamInfo.questionBank[this.pushIndex].questionTypeId ==
              item.questionTypeId
            ) {
              item.questions.push(this.testExamInfo.questionBank[this.pushIndex]);
            }
          });
        }
        this.pushIndex++;
      }
    },
    // 通关模式（判断当前题目是否正确）
    async judgeIsCorrect() {
      // 题目处理
      this.testPaperInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          // 这里处理下多选题的答案和用户答案的数据结构将数组转换成字符串
          if (sitem.questionTypeId == 2) {
            if (Array.isArray(sitem.questionContext.answer)) {
              sitem.questionContext.answer = sitem.questionContext.answer.join(",");
            }
            if (Array.isArray(sitem.questionContext.doAnswer)) {
              sitem.questionContext.doAnswer = sitem.questionContext.doAnswer.join(",");
            }
            if (Array.isArray(sitem.doAnswer)) {
              sitem.doAnswer = sitem.doAnswer.join(",");
            }
          }
          if (
            sitem.questionTypeId == 99 ||
            item.questionTypeId == 101 ||
            item.questionTypeId == 102 ||
            item.questionTypeId == 103
          ) {
            sitem.questionContext.subQuestions.forEach((ssitem) => {
              // 综合解答下的多选题
              if (ssitem.type == 2) {
                // let aaa = this.$Tools.copyObj(ssitem);
                // 判断题处理数据格式
                if (Array.isArray(ssitem.answer)) {
                  ssitem.answer = ssitem.answer.join(",");
                }
                if (Array.isArray(ssitem.doAnswer)) {
                  ssitem.doAnswer = ssitem.doAnswer.join(",");
                }
                // return aaa
              }
            });
          }
          // 作文题
          if (sitem.questionTypeId == 21 || item.questionTypeId == 22) {
            sitem.doAnswer = JSON.stringify(sitem.doAnswer);
          }
          // listParams.questions.push(sitem);
        });
      });
      // 首先，找到当前题目
      let currentQuestion = null;
      for (const item of this.testPaperInfo.paperContext) {
        for (const sitem of item.questions) {
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            currentQuestion = sitem;
            break;
          }
        }
        if (currentQuestion) break;
      }
      if (!currentQuestion) {
        return false; // 如果没有找到当前题目，返回false
      }
      // 构建参数
      let listParams = {
        paperId: this.testExamInfo.paperId,
        examId: this.testExamInfo.examId,
        isSubmit: 2, // 是否提交：1：提交 2：未提交保存进度
        questions: [currentQuestion],
      };
      if (this.isChallengeSubmit) {
        listParams.sort = this.challengeSort;
      }
      try {
        const res = await this.$Api.exam.saveExam(listParams);
        let isCorrect = res.data.data[0]?.isCorrectQuestion;
        return isCorrect == 1;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    // 普通模式展示解析
    async showAnalysis(flag) {
      // 通关模式（判断对错，错了直接提交）
      if (this.testExamInfo.otherRule?.mode == 2) {
        let flag = await this.judgeIsCorrect();
        if (flag == false) {
          this.commitPaper(3);
        }
      } else if (this.testExamInfo.otherRule?.mode == 3) {
        let flag = await this.judgeIsCorrect();
        if (flag == false) {
          let pushQuestionNumber = this.testExamInfo.otherRule?.pushQuestionNumber;
          for (let i = 0; i < pushQuestionNumber; i++) {
            // 错题累加
            this.pushWrongQuestion();
          }
        }
      }
      this.testPaperInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            if (flag) {
              if (sitem.questionContext.isFinish == false) {
                this.$Dialog.toast("请先完成答题后再查看");
                return;
              } else {
                sitem.showAnalysis = true;
              }
            } else {
              sitem.showAnalysis = true;
            }
          }
        });
      });
    },
    // 单题提交展示结果等
    confirmQuestion() {
      let listQuery = {
        courseId: this.selectLearningInfo.courseId,
        chapterId: this.selectLearningInfo.chapterId,
        schemeId: this.selectLearningInfo.schemeId,
        phaseId: this.selectLearningInfo?.id,
        roundId: this.selectLearningInfo.roundId,
        // paperId: this.testExamInfo.paperId,
        paperRecordJson: [],
        practiceType: 1, // 1=预热练习, 2=正式纠错
        isSubmit: 1, // 是否提交：1：提交 2：未提交
      };
      this.testExamInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          // 这里处理下多选题的答案和用户答案的数据结构将数组转换成字符串
          if (sitem.questionTypeId == 2) {
            if (Array.isArray(sitem.questionContext.answer)) {
              sitem.questionContext.answer = sitem.questionContext.answer.join(",");
            }
            if (Array.isArray(sitem.questionContext.doAnswer)) {
              sitem.questionContext.doAnswer = sitem.questionContext.doAnswer.join(",");
            }
            if (Array.isArray(sitem.doAnswer)) {
              sitem.doAnswer = sitem.doAnswer.join(",");
            }
          }
          if (
            sitem.questionTypeId == 99 ||
            item.questionTypeId == 101 ||
            item.questionTypeId == 102 ||
            item.questionTypeId == 103
          ) {
            sitem.questionContext.subQuestions.forEach((ssitem) => {
              // 综合解答下的多选题
              if (ssitem.type == 2) {
                // let aaa = this.$Tools.copyObj(ssitem);
                // 判断题处理数据格式
                if (Array.isArray(ssitem.answer)) {
                  ssitem.answer = ssitem.answer.join(",");
                }
                if (Array.isArray(ssitem.doAnswer)) {
                  ssitem.doAnswer = ssitem.doAnswer.join(",");
                }
                // return aaa
              }
            });
          }
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            listQuery.paperRecordJson.push(sitem);
          }
        });
      });
      // this.$Api.exam.saveUserPhaseWrongQuestion(listQuery).then(() => {
      this.testPaperInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            if (sitem.questionContext.isFinish == false) {
              this.$Dialog.toast("请先完成答题后再查看");
              return;
            } else {
              sitem.showAnalysis = true;
            }
          }
        });
      });
      // }).catch(() => { })
    },
    // 提交试卷
    commitPaper(isSubmit) {
      let listParams = {
        paperId: this.testExamInfo.paperId,
        examId: this.testExamInfo.examId,
        isSubmit: isSubmit, // 是否提交：1：提交 2：未提交保存进度
        questions: [],
      };
      this.testExamInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          // 这里处理下多选题的答案和用户答案的数据结构将数组转换成字符串
          if (sitem.questionTypeId == 2) {
            if (Array.isArray(sitem.questionContext.answer)) {
              sitem.questionContext.answer = sitem.questionContext.answer.join(",");
            }
            if (Array.isArray(sitem.questionContext.doAnswer)) {
              sitem.questionContext.doAnswer = sitem.questionContext.doAnswer.join(",");
            }
            if (Array.isArray(sitem.doAnswer)) {
              sitem.doAnswer = sitem.doAnswer.join(",");
            }
          }
          if (
            sitem.questionTypeId == 99 ||
            item.questionTypeId == 101 ||
            item.questionTypeId == 102 ||
            item.questionTypeId == 103
          ) {
            sitem.questionContext.subQuestions.forEach((ssitem) => {
              // 综合解答下的多选题
              if (ssitem.type == 2) {
                // let aaa = this.$Tools.copyObj(ssitem);
                // 判断题处理数据格式
                if (Array.isArray(ssitem.answer)) {
                  ssitem.answer = ssitem.answer.join(",");
                }
                if (Array.isArray(ssitem.doAnswer)) {
                  ssitem.doAnswer = ssitem.doAnswer.join(",");
                }
                // return aaa
              }
            });
          }
          // 作文题
          if (sitem.questionTypeId == 21 || item.questionTypeId == 22) {
            sitem.doAnswer = JSON.stringify(sitem.doAnswer);
          }
          listParams.questions.push(sitem);
        });
      });
      if (this.isChallengeSubmit) {
        listParams.sort = this.challengeSort;
      }

      this.$Api.exam
        .saveExam(listParams)
        .then((res) => {
          // this.$Dialog.toast("提交成功");
          this.$emit("refreshTextExam");
          // 此处加入判断，判断提交后当前步骤是否已完成，已完成则可以选择点击进入下一步/下一章节阶段
          this.judgeStepStatus();
          setTimeout(() => {
            if (this.isChallengeSubmit) {
              this.paperCommitBackInfo = res?.data?.data;
              this.changeExamInfoIsShowScoring();
              this.getChallengeResult();
              // // 此处新增系统判分逻辑----调用查询作答记录（后台判分）,用于刷新答题后状态
              this.getUserExamRecord(res?.data?.data?.recordId);
            }
          }, 1000);
        })
        .catch(() => {});
    },
    // 此处用于判断提交后当前步骤是否已完成，已完成则可以选择点击进入下一步/下一章节阶段
    judgeStepStatus() {
      let stepNum = this.schoolMenu;
      this.$Api.course
        .getMyCourseChapterProgress({
          schemeChapterPhaseId: this.selectLearningInfo?.id,
        })
        .then((res) => {
          let stepStatus = 0;
          let labelText = "";
          // 2 作业，3 闯关 4 纠错 5 通关
          if (stepNum == 2) {
            stepStatus = res.data.data.outputStatus;
            labelText = "作业";
          } else if (stepNum == 3) {
            // 闯关无需弹窗提示是否进入下一步
            // stepStatus = res.data.data.passStatus;
            labelText = "闯关";
          } else if (stepNum == 4) {
            // stepStatus = res.data.data.outputStatus;
          } else if (stepNum == 5) {
            stepStatus = res.data.data.finalStatus;
            labelText = "通关";
          }
          if (stepStatus == 1) {
            this.$Dialog.confirm({
              message: `当前${labelText}已全部完成，是否前往下一步`,
              title: "提示", // 可选，不传则使用默认值'确认'
              onConfirm: () => {
                // 退出答题页面
                this.practiceBack();
                setTimeout(() => {
                  this.$store.commit("learning/setStudyStepInfo", stepNum);
                }, 500);
              },
              onCancel: () => {
                // this.backStep();
              },
            });
          }
        })
        .catch(() => {});
    },
    // 试题提交控制显示试卷的结果分数
    changeExamInfoIsShowScoring() {
      this.testExamInfo.isShowScoring = true;
      // 默认到第一题
      this.testExamInfo.currentQuestionId = 1;
      this.$store.commit("exam/setTestExamInfo", this.testExamInfo);
    },
    getChallengeResult() {
      if (!this.$Tools.empty(this.paperCommitBackInfo)) {
        this.$refs.challengePopup.isSuccess =
          this.paperCommitBackInfo.isCorrect == 1 ? true : false;
        this.$refs.challengePopup.challengeInfo.num = this.paperCommitBackInfo.totalCount;
        this.$refs.challengePopup.challengeInfo.percent =
          this.paperCommitBackInfo.correctRate + "%";
        this.$refs.challengePopup.challengeInfo.time = this.$Tools.secondToMinuteFormatNew(
          this.paperCommitBackInfo.answerSection
        );
        this.$refs.challengePopup.challengePopupShow = true;
      } else {
        this.$Dialog.toast("数据有误", { type: "warning" });
      }
    },
    // 答题(刷新缓存试题便于提交)
    answerQuestion(info) {
      if (this.testPaperInfo.paperContext) {
        // 1. 使用 map 返回新 paperContext 数组
        const newPaperContext = this.testPaperInfo.paperContext.map((item) => {
          // 2. 使用 map 返回新 questions 数组
          const newQuestions = item.questions.map((sitem) => {
            if (sitem.questionNumber === info.questionNumber) {
              // 返回替换后的新对象
              return this.$Tools.copyObj(info);
            } else {
              // 保留原对象
              return sitem;
            }
          });

          // 3. 将新 questions 数组赋值回当前 item
          return { ...item, questions: newQuestions };
        });

        // 4. 更新整个 paperContext
        this.testPaperInfo.paperContext = newPaperContext;
        this.$store.commit("exam/setTestExamInfo", this.testPaperInfo);
      }
    },
    // 此处新增系统判分逻辑----调用查询作答记录（后台判分）
    getUserExamRecord(recordId) {
      this.$Api.exam
        .getUserExamRecord(recordId)
        .then((res) => {
          let examInfo = res.data.data;
          examInfo.isShowScoring = true;

          // 第一次没有当前所做题目id设置第一个题目为当前所在题
          if (!examInfo.currentQuestionId) {
            examInfo.currentQuestionId =
              examInfo.paperContext[0]?.questions[0]?.questionNumber; // 初始化默认第一个题目ID
          }
          this.$store.commit("exam/setTestExamInfo", examInfo);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.test_paper {
  .paper_top {
    .empty {
      width: 1px;
      height: 1px;
    }

    .count_down {
      // width: 170px;
      height: 36px;
      background: linear-gradient(-42deg, #f45f0a 1%, #ed752f 100%);
      box-shadow: 0px 0px 9px 0px rgba(254, 121, 47, 0.53),
        0px 3px 3px 0px rgba(255, 255, 255, 0.23);
      border-radius: 10px;
      color: #ffffff;
      padding: 0 20px;
      line-height: 36px;
      margin-left: 60px;
    }

    .back_icon {
      width: 28px;
      height: 28px;
    }

    .back_text {
      font-size: 14px;
      color: #13d6aa;
      margin-left: 7px;
    }
  }

  .test_title {
    font-size: 20px;
    color: #111111;
    text-align: center;
  }

  .test_type {
  }

  .btn_box {
    justify-content: center;

    .btn_previous_question {
      width: 200px;
      height: 48px;
      border-radius: 24px;
      border: 1px solid #13d6aa;
      line-height: 48px;
      text-align: center;
      color: #13d6aa;
      font-size: 18px;
    }

    .btn_next_question {
      width: 200px;
      height: 48px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 24px;
      line-height: 48px;
      text-align: center;
      color: #ffffff;
      font-size: 18px;
    }
  }
}
</style>
